import { isLiteMode } from 'src/utils/liteMode';
import { FeatureFlags } from './types';

export enum FeatureFlag {
  videoCards = 'videoCards',
  newDatesAndPrices = 'newDatesAndPrices', // datesAndPricesV2
  datesAndPricesV3 = 'datesAndPricesV3',
  dailyPricingTripPage = 'dailyPricingTripPage',
  newCheckout = 'newCheckout',
  customerQuotes = 'customerQuotes',
  wizardV5 = 'wizardV5',
  liteMode = 'lite',
  newTripPage = 'newTripPage',
  tripFacts = 'tripFacts',
  productLineFilter = 'productLineFilter',
  connectedFilters = 'connectedFilters',
}

export const featureFlagDefaults: Required<FeatureFlags> = {
  [FeatureFlag.videoCards]: false,
  [FeatureFlag.newDatesAndPrices]: true,
  [FeatureFlag.datesAndPricesV3]: true,
  [FeatureFlag.dailyPricingTripPage]: false,
  [FeatureFlag.newCheckout]: true,
  [FeatureFlag.customerQuotes]: false,
  [FeatureFlag.wizardV5]: true,
  [FeatureFlag.liteMode]: isLiteMode,
  [FeatureFlag.newTripPage]: false,
  [FeatureFlag.tripFacts]: false,
  [FeatureFlag.connectedFilters]: false,
  [FeatureFlag.productLineFilter]: true,
};
